<template>
  <v-card class="text-center">
    <validation-observer v-slot="{ handleSubmit }">
      <v-card-title class="text-center head-content-change-teacher">
        Những học sinh có cùng SĐT sẽ được chuyển cùng một Quản lý lớp
      </v-card-title>
      <v-card-text class="px-6">
        <v-simple-table
          class="table-layout table-fixed"
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center header-content">SDT</th>
                <th class="text-center header-content">Học viên</th>
                <th class="text-center header-content">
                  Quản lý lớp xác nhận chuyển mới
                </th>
              </tr>
            </thead>
            <tbody v-if="dataConverted && dataConverted.length">
                <template v-for="(item, key) in dataConverted">
                  <tr :key="key">
                    <td :rowspan="caclRowSpan(item)" v-if="isFirstOfGroup(item, key)">{{ item.phone }}</td>
                    <td>
                      <span
                      class="m-auto"
                      :class="!item.main ? 'same-phone' : ''"
                      >{{ item.full_name }}
                      <span v-if="!item.main">- cùng SĐT</span></span>
                    </td>
                    <td v-if="key === 0" :rowspan="dataConverted.length"> {{ gvcn.name }}</td>
                  </tr>
                </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3">Không có kết quả nào phù hợp</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions
        class="px-0 px-4 w-full"
      >
        <div class="content-confirm-change-teacher">Bạn có muốn đổi Quản lý lớp ?</div>
        <div class="d-flex justify-space-between" style="width: 27%;float:right">
          <v-btn class="cancel-button" @click="$emit('close')">Hủy bỏ</v-btn>
          <v-spacer />
          <v-btn class="update-button" @click.prevent="handleSubmit(saveChange)"
            >Xác nhận</v-btn
          >
        </div>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import BlendedCareServices from '../../../services/BlendedCareRepository';

export default {
  props: {
    commonTeacher: {
      type: Object,
      default: () => {},
    },
    selectionData: {
      type: Object,
      default: () => {},
    },
    gvcn: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      teaherPIC: 0,
      dataConverted: [],
    };
  },
  computed: {
    dataTable() {
      const transformedArray = Object.keys(this.commonTeacher).map((key) => ({
        phone: key,
        value: this.commonTeacher[key],
      }));
      return transformedArray;
    },
  },
  created() {
    this.dataTable.forEach((item) => {
      this.dataConverted = [...this.dataConverted, ...item.value.map((itemV) => ({ ...itemV, phone: item.phone }))];
    });
  },
  methods: {
    isFirstOfGroup(itemParam, key) {
      const arrPhone = this.dataConverted.map((item) => item.phone);
      return arrPhone.indexOf(itemParam.phone) === key;
    },
    caclRowSpan(itemParam) {
      return this.dataConverted.filter((item) => item.phone === itemParam.phone).length;
    },
    async saveChange() {
      const loading = this.$loading.show();
      const result = await BlendedCareServices.updateTeacher({
        ids: this.selectionData.ids,
        teacherId: this.selectionData.userId,
      });
      loading.hide();
      if (result && result.message === 'Success') {
        this.$swal({
          type: 'success',
          title: 'Thành công',
          text: 'Chuyển quản lý lớp thành công!!!',
        });
        this.$emit('done');
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: `Có lỗi khi chuyển quản lý lớp: ${result.message} !!!`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  td,
  th {
    border-bottom: none !important;
    border: thin solid rgba(0, 0, 0, 0.12);
  }
}
.content-confirm-change-teacher {
  color: #333;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 133.333% */
}
.header-content {
  color: #52526c !important;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 13px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 153.846% */
}
.head-content-change-teacher {
  color: #333 !important;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 15px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  padding-bottom: 24px !important;
}
.same-phone {
  color: #0d47a1;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 166.667% */
}
.w-full {
  width: 100%;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #bdbdbd !important;
  color: white;
}
</style>
